import { FileType } from '@Components/FileUploadDropzone/FileTypes';

export interface IFileSelectResult {
    isValid: boolean;
    message: string;
    fileType?: FileType;
}

export function getFileTypeFromFile(file: File): FileType {
    switch (file.type) {
        case 'image/jpeg':
            return FileType.JPG;
        case 'text/csv':
            return FileType.CSV;
    }
}
